var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-2 mt-1",attrs:{"color":"primary","elevation":"0"},on:{"click":function($event){return _vm.save()}}},[_vm._v("Exportovat "+_vm._s(_vm.rAttendees.length)+" ratingů")])}
var staticRenderFns = []

export { render, staticRenderFns }